import { Box, Chip, Paper, Typography } from '@mui/material';
import getStatusInfo from 'components/DeviceInfoStatus';

const DeviceCard = ({
  type,
  status,
  imei,
}: {
  type: string;
  status?: string;
  imei?: string | null;
}) => {
  const statusInfo = getStatusInfo(status);

  return (
    <Box
      sx={{
        width: 90,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        marginLeft: 2,
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: '100%',
          height: 40,
          backgroundColor: statusInfo.color,
          border: `2px solid ${statusInfo.borderColor}`,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: 3,
          },
          padding: '0 10px',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontSize: 12,
            fontWeight: 'medium',
            color: statusInfo.textColor,
          }}
        >
          {type}
        </Typography>
        <Box sx={{ color: statusInfo.textColor, fontSize: 10 }}>
          {statusInfo.icon}
        </Box>
      </Paper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Chip
          label={status === 'Acknowledgement Signed' ? imei : statusInfo.label}
          size="small"
          sx={{
            height: 13,
            backgroundColor: statusInfo.color,
            color: statusInfo.textColor,
            fontWeight: 'medium',
            borderColor: statusInfo.borderColor,
            fontSize: 8,
          }}
        />
        {/* {imei && (
            <Tooltip title={`IMEI: ${imei}`}>
              <Typography variant="caption" color="text.secondary">
                ID: {imei.slice(-6)}
              </Typography>
            </Tooltip>
          )} */}
      </Box>
    </Box>
  );
};

export default DeviceCard;
